function checkDateExists(dateString, projectData) {
    const result = {
        exists: false,
        totalAssignWorkOne: 0,
        totalAssignWorkWithImages: 0
    };

    const targetKey = `dateStamp:${dateString}`;

    function searchForDateKey(node) {
        if (typeof node !== 'object' || node === null) return;

        for (const [key, value] of Object.entries(node)) {
            if (key === targetKey) {
                result.exists = true;
                processTeams(value);
                return; // Early exit once date is found and processed
            } else if (typeof value === 'object') {
                searchForDateKey(value);
            }
        }
    }

    function processTeams(dateData) {
        ['labourInformation', 'contractorInformation'].forEach(section => {
            const teams = dateData?.[section];
            if (teams && typeof teams === 'object') {
                Object.values(teams).forEach(team => {
                    if (team?.assignWorkOne === true) {
                        result.totalAssignWorkOne++;
                        if (
                            team.humanImage &&
                            typeof team.humanImage === 'object' &&
                            Object.keys(team.humanImage).length > 0
                        ) {
                            result.totalAssignWorkWithImages++;
                        }
                    }
                });
            }
        });
    }

    searchForDateKey(projectData);
    return result;
}

export default checkDateExists;
